import layout from '@/layout'

/**
 * 新增独立的量化工作台一级菜单。
 * 不放入“搜索”：该页同时承担数据编排、结果观察和方案管理，不属于单一搜索策略。
 */
export default {
  path: '/data-workbench',
  component: layout,
  redirect: '/data-workbench/index',
  name: 'dataWorkbench',
  meta: {
    title: 'dataWorkbench',
    icon: 'other'
  },
  children: [
    {
      path: '/data-workbench/index',
      name: 'dataWorkbenchIndex',
      component: () => import('@/views/data-workbench/index.vue'),
      meta: {
        title: 'dataWorkbenchIndex',
        icon: 'other'
      }
    }
  ]
}
